import React from 'react';
import styled from 'styled-components';
import { useState, useEffect } from 'react';
import InboxTable from './InboxTable';
import AssetRequestDetails from '../IssueReq/AssetRequestDetails';
import UserAsstRtrnReqDetails from '../UserAssetReturnReq/UserAsstRtrnReqDetails'
import BoAsstRtrnReqDetails from '../BoAssetReturnReq/BoAsstRtrnReqDetails';
import { useMarkAsReadMutation } from '../../../../features/assetrequest/assetReqApiSlice';

const Container = styled.div``
const Wrapper = styled.div``

const Inbox = ({subTabValue, resetTrigger}) => {
  const [row, setRow] = useState('')
  const [changepage, setChangepage] = useState([true, false, false, false, false])
  const [markAsReadMutation] = useMarkAsReadMutation();

  useEffect(() => {
    if (resetTrigger > 0) {
      setChangepage([true, false, false, false, false]);
      // Reset any other state variables that need resetting
    }

  },[resetTrigger])
  
  const handleEditclick = async (e, row, reqtype) => {
    console.log(reqtype);
    setRow(row);
    
    // Mark the request as read when user clicks view/action button
    try {
      await markAsReadMutation({
        requestId: row._id || row.id,
        requestType: 'asset'
      }).unwrap();
      console.log('Request marked as read successfully');
    } catch (error) {
      console.error('Error marking request as read:', error);
    }
  
    if (["Individual_Issue", "Issue"].includes(reqtype)) {
      setChangepage([false, true, false, false, false]);
    } else if (
      [
        "Ind_Asset_Return_Bo",
        "Asset_Return_Bo",
        "Asset_Return_Store_Via_BO",
        "IndAsset_Rtrn_Str_Direct"        
      ].includes(reqtype)
    ) {
      setChangepage([false, false, true, false, false]);
    } else if (["BO_User_Transfer", "BO_Store_Return"].includes(reqtype)) {
      setChangepage([false, false, false, true, false]);
    } else if (reqtype === "direct") {
      setChangepage([false, false, false, false, true]);
    }
  };
  
// 'Ind_Asset_Return_Bo' : "Asset_Return_Bo"
  return (
    <Container>
      <Wrapper>
        {(changepage[0] ) && <InboxTable subTabValue={subTabValue}  handleEditclick={handleEditclick} />}
        {(changepage[1] ) && <AssetRequestDetails row={row} subTabValue={subTabValue} setChangepage={setChangepage} />}
        {(changepage[2] ) && <UserAsstRtrnReqDetails row={row} subTabValue={subTabValue} setChangepage={setChangepage} />}
        {(changepage[3] ) && <BoAsstRtrnReqDetails row={row} subTabValue={subTabValue} setChangepage={setChangepage} />}
      </Wrapper>
    </Container>
  )
}



export default Inbox